import React from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import PurchaseDetailsDrawer from "./Ussd/PurchaseDetailsDrawer";
import SessionDetailsDrawer from "./Ussd/SessionDetailsDrawer";
import TransportDetailsDrawer from "./Ussd/TransportDetails/TransportDetailsDrawer";
import RentalDetailsDrawer from "./Rentals/TransportDetails/RentalDetailsDrawer";

const RequestDetailsDrawer = ({
  visible,
  onCancel,
  currentPage,
  setCurrentPage,
}) => {
  const { currentRequest } = useSelector((state) => state.requests);

  const [searchParams] = useSearchParams();
  const selectedTab = searchParams.get("tab");

  if (!visible) return null;

  if (selectedTab === "rentals") {
    return (
      <RentalDetailsDrawer
        key="rentals"
        visible={visible}
        onCancel={onCancel}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    );
  }

  if (currentRequest.type === "taas") {
    return (
      <TransportDetailsDrawer
        key="taas"
        visible={visible}
        onCancel={onCancel}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    );
  }

  if (currentRequest.type === "purchase-feed") {
    return (
      <PurchaseDetailsDrawer
        key="purchase-feed"
        visible={visible}
        onCancel={onCancel}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    );
  }

  if (currentRequest.type === "power-africa") {
    return (
      <SessionDetailsDrawer
        key="power-africa"
        visible={visible}
        onCancel={onCancel}
      />
    );
  }

  return null;
};

export default RequestDetailsDrawer;
